class CriticalLoginException extends Error {
    public name = "CriticalLoginException";
    constructor(message: string) {
        super(message);
    }
}

export default CriticalLoginException;
